import React from 'react'

class All extends React.Component {
  render () {
    return (
      <>
        
        
        {/* <!-- Our Schedule Area Start --> */}
        
        <section className='our-ticket-pricing-table-area bg-img bg-gradient-overlay section-padding-100-0 jarallax' style={{backgroundImage: 'url(img/bg-img/bg-2.jpg)'}}>
        <div className='container'>
            <div className='row'>
                <div className='col-12'>
                    <div className='section-heading text-center wow fadeInUp' data-wow-delay='300ms'>
                        <p>Choose a Model</p>
                        <h4>RoboChef Variants</h4>
                    </div>
                </div>
            </div>

            <div className='row'>
                <div className='col-12 col-lg-4'>
                    <div className='single-ticket-pricing-table text-center mb-100 wow fadeInUp' data-wow-delay='300ms'>
                        <h6 className='ticket-plan'>Domestic</h6>
                        <div className='ticket-icon'>
                            <img src='img/core-img/11.png' alt=''/>
                        </div>
                        <h2 className='ticket-price'>D<span>370</span></h2>
                        <a href='#contact' className='btn confer-btn w-100 mb-30'>Get Quotes <i className='zmdi zmdi-long-arrow-right'></i></a>
                        
                        <div className='ticket-pricing-table-details'>
                            <p><i className='zmdi zmdi-check'></i> 1 Vessel</p>
                            <p><i className='zmdi zmdi-check'></i> 3 - 4 Servings</p>
                            <p><i className='zmdi zmdi-check'></i> Mobile App</p>
                            <p><i className='zmdi zmdi-check'></i> 3.7 Litre Capacity</p>
                            <p><i className='zmdi zmdi-check'></i> Customise Recipes</p>
                            <p><i className='zmdi zmdi-check'></i> 2.5kW Required Power</p>
                        </div>
                    </div>
                </div>

                <div className='col-12 col-md-6 col-lg-4'>
                    <div className='single-ticket-pricing-table text-center mb-100 wow fadeInUp' data-wow-delay='300ms'>
                        <h6 className='ticket-plan'>Commercial</h6>
                        <div className='ticket-icon'>
                            <img src='img/core-img/33.jpg' alt=''/>
                        </div>
                        <h2 className='ticket-price'>CX<span>3700</span></h2>
                        <a href='#contact' className='btn confer-btn w-100 mb-30'>Get Quotes <i className='zmdi zmdi-long-arrow-right'></i></a>
                        <div className='ticket-pricing-table-details'>
                        <p><i className='zmdi zmdi-check'></i> 2 Vessels</p>
                            <p><i className='zmdi zmdi-check'></i> 100 Servings</p>
                            <p><i className='zmdi zmdi-check'></i> Mobile App</p>
                            <p><i className='zmdi zmdi-check'></i> 37 Litre Capacity</p>
                            <p><i className='zmdi zmdi-check'></i> Customise Recipes</p>
                            <p><i className='zmdi zmdi-check'></i> 10kW Required Power</p>
                        </div>
                    </div>
                </div>

                <div className='col-12 col-md-6 col-lg-4'>
                    <div className='single-ticket-pricing-table active text-center mb-100 wow fadeInUp' data-wow-delay='300ms'>
                        <h6 className='ticket-plan'>SSR</h6>
                        <div className='ticket-icon'>
                            <img src='img/core-img/22.jpg' alt=''/>
                        </div>
                        <h2 className='ticket-price'>QX<span>770</span></h2>
                        <a href='#contact' className='btn confer-btn w-100 mb-30'>Get Quotes <i className='zmdi zmdi-long-arrow-right'></i></a>
                        
                        <div className='ticket-pricing-table-details'>
                        <p><i className='zmdi zmdi-check'></i> 2 Vessels</p>
                            <p><i className='zmdi zmdi-check'></i> 20 Servings</p>
                            <p><i className='zmdi zmdi-check'></i> Mobile App</p>
                            <p><i className='zmdi zmdi-check'></i> 7.7 Litre Capacity</p>
                            <p><i className='zmdi zmdi-check'></i> Customise Recipes</p>
                            <p><i className='zmdi zmdi-check'></i> 5kW Required Power</p>
                        </div>
                    </div>
                </div>

            </div>
            </div>
    </section>
        {/* <!-- Our Schedule Area End --> */}


      </>
    )
  }
}

export default All
